import type { TasteProfileWire } from '../schemas/taste-profile';
import type { TasteProfile } from '@/types/taste-profile';

/** Wire -> domain. Returns a new object; never mutates the input. */
export function mapTasteProfileWireToDomain(wire: TasteProfileWire): TasteProfile {
  return {
    cuisines: wire.cuisines.map((c) => ({ id: c.id, slug: c.slug, name: c.name, valence: c.valence })),
    allergens: wire.allergens.map((a) => ({ id: a.id, slug: a.slug, name: a.name })),
    dietaryProfiles: wire.dietaryProfiles.map((d) => ({ id: d.id, slug: d.slug, name: d.name })),
  };
}
